import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import HomePage from './pages/HomePage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AddVenuePage from './pages/AddVenuePage';
import EditVenuePage from './pages/EditVenuePage';
import SingleVenuePage from './pages/SingleVenuePage';
import { useGTM } from './hooks/useGTM';

// Create a wrapper component that uses GTM
const AppContent = () => {
  useGTM();
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/venue/:venueId" element={<SingleVenuePage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      
      {/* Protected admin routes */}
      <Route element={<ProtectedAdminRoute />}>
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/venues/new" element={<AddVenuePage />} />
        <Route path="/admin/venues/edit/:venueId" element={<EditVenuePage />} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AdminAuthProvider>
  );
}

export default App;